import { createApp } from 'vue'
import App from './App.vue'
import { PiniaSingleton } from '@/plugins/pinia'
import router from './router'
import { Request } from '@/plugins/http'
import VueAxios from 'vue-axios'
import './style/element-variables.scss'
import './style/index.scss'
import './style/public.scss'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { CountDown } from 'vant'
import setDirectives from '@/directive/index'
import start from '@/service'

const pinia = PiniaSingleton.getInstance()
const app = createApp(App)
app.use(VueAxios, Request.init())

createApp(App)
	.use(pinia)
	.use(ElementPlus, {
		locale: zhCn
	})
	.use(router)
	.use(setDirectives)
	.use(CountDown)
	.mount('#app')

start({
	prefetch: 'all',
	sandbox: { experimentalStyleIsolation: true }
})